<template>
  <div class="mainLayout">
    <H2>TopTrack DeviceLogs</H2>
    <div class="board px-2 row d-flex justify-content-center align-items-center">
      <label class="col-auto">裝置序號:</label>
      <input class="col-auto mx-2" type="text" v-model="searchDeviceSerialNumber"/>
      <label class="col-auto">日期:</label>
      <Datepicker class="col-auto" v-model="selectTime" :minDate="minDate" :clearable="false" :enableTimePicker="false" :maxDate="new Date()" autoApply/>
      <button class="col-auto btn btn-primary" @click="onSearchButtonClickEvent">查詢</button>
    </div>
    <label class="mt-2 mx-2">檔案名稱:{{ fileName }}</label>
    <label class="mt-2 mx-2"></label>
    <div class="logList d-flex justify-content-center">
      <div class="table-content">
        <table class="table table-sm table-striped align-middle mt-2">
          <thead class="table-primary">
            <tr>
              <th scope="col" class="col-auto">#</th>
              <th scope="col" class="col">接收時間</th>
              <th scope="col" class="col">機器資訊</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in searchResultData" :key="index">
              <th scope="row" v-text="index + 1"></th>
              <th class="time" v-text="new Date(data.timestamp / 1000).toLocaleString()"></th>
              <th class="content " v-text="data.data"></th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'

export default {
  setup () {
    const selectTime = ref(new Date())
    const minDate = computed(() => {
      const now = new Date()
      return new Date(now.setDate(now.getDate() - 60))
    })
    const searchDeviceSerialNumber = ref('')
    const searchResultData = ref([])
    const fileName = ref('')

    function getLogFileName () {
      return getDateString(selectTime.value) + '_' + searchDeviceSerialNumber.value + '.log'
    }

    function getDateString (date) {
      var mm = date.getMonth() + 1
      var dd = date.getDate()
      return [date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('')
    }

    function getSearchFileData () {
      fileName.value = getLogFileName()
      searchResultData.value.length = 0
      loadTextLog(fileName.value).then((result) => {
        if (result) {
          const jsonData = result.split(new RegExp('\\r\\n', 'g'))
          for (var i = 0; i < jsonData.length; i++) {
            const data = jsonData[i]
            if (data !== '') {
              searchResultData.value.push({ timestamp: getTimeStampValue(data), data: getDataValue(data) })
            }
          }
        }
      })
    }

    function getDataValue (str) {
      const dataIndex = str.indexOf('data')
      const firstIndex = str.indexOf(':', dataIndex)
      return str.substr(firstIndex + 2, str.length - firstIndex - 4)
    }

    function getTimeStampValue (str) {
      const timestampIndex = str.indexOf('timestamp')
      const firstIndex = str.indexOf(':', timestampIndex)
      const commonIndex = str.indexOf(',')
      return str.substr(firstIndex + 1, commonIndex - firstIndex - 1)
    }

    async function loadTextLog (fileName) {
      const filePath = '/DeviceLogs/' + fileName
      const response = await fetch(filePath)
      const content = await response.text().then((str) => {
        return str.includes('<!DOCTYPE html>') ? null : str
      }).catch((err) => {
        console.log(err)
      })
      return content
    }

    function onSearchButtonClickEvent () {
      if (searchDeviceSerialNumber.value !== '') {
        getSearchFileData()
      }
    }

    return {
      minDate,
      fileName,
      searchDeviceSerialNumber,
      selectTime,
      searchResultData,
      onSearchButtonClickEvent
    }
  }
}
</script>

<style lang="stylus" scoped>
.mainLayout {
  overflow: hidden
}
.table-content {
  overflow: auto
  width: 90%
  .table {
    height: calc(100vh - 20rem)
    & thead {
      position: sticky
      top: 0
    }
    .time {
      font-size: 12px
    }
    .content {
      font-size: 12px
    }
  }
}
</style>
